import { IonChip, IonLabel } from '@ionic/react';
import { FileTextIcon, IconProps, PlusCircleIcon } from '@phosphor-icons/react';
import React from 'react';

import Button from '../../UI/Button';
import Spinner from '../../UI/Spinner';
import '../ReintegroCard/ReintegroCard.scss';

interface VacunaReintegroCardProps {
  comprobantes: any[];
  documentacionCompleta: boolean;
  isLoadingComprobantes?: boolean;
  onEditDocumentacion?: () => void;
  onAddComprobante?: () => void;
  openComprobantesGallery?: () => void;
}

const iconProps: IconProps = { size: 24, weight: 'fill' };

const VacunaReintegroCard: React.FC<VacunaReintegroCardProps> = ({
  comprobantes = [],
  documentacionCompleta,
  isLoadingComprobantes,
  onEditDocumentacion,
  onAddComprobante,
  openComprobantesGallery,
}) => {
  const cantidad = comprobantes.length;

  return (
    <div className="reintegro-card">
      <div className="reintegro-card__header">
        <h3 className="reintegro-card__title">Vacuna</h3>
      </div>

      <div
        className={`reintegro-card__content${cantidad === 0 ? ' reintegro-card__content--compact' : ''}`}
      >
        {/* Documentacion */}
        <div className="reintegro-card__row">
          <span className="reintegro-card__label">Documentacion</span>
          <div className="reintegro-card__row-actions">
            {documentacionCompleta ? (
              <IonChip color="success" className="reintegro-card__chip">
                <IonLabel>Completada</IonLabel>
              </IonChip>
            ) : (
              <IonChip color="danger" className="reintegro-card__chip">
                <IonLabel>Incompleta</IonLabel>
              </IonChip>
            )}
            {!documentacionCompleta && onEditDocumentacion && (
              <button onClick={onEditDocumentacion} className="reintegro-card__icon-btn">
                <FileTextIcon {...iconProps} />
              </button>
            )}
          </div>
        </div>

        {/* Comprobantes */}
        <div className="reintegro-card__row">
          <span className="reintegro-card__label">Comprobantes</span>
          <div className="reintegro-card__row-actions">
            {isLoadingComprobantes ? (
              <Spinner />
            ) : (
              <>
                <span className="reintegro-card__value">{cantidad || 'Ninguno'}</span>
                {onAddComprobante && (
                  <button onClick={onAddComprobante} className="reintegro-card__icon-btn">
                    <PlusCircleIcon {...iconProps} />
                  </button>
                )}
              </>
            )}
          </div>
        </div>

        {cantidad > 0 && (
          <div className="ion-padding-horizontal" style={{ paddingBottom: 20 }}>
            <Button
              noMarginTop
              marginBottom={false}
              fill="outline"
              size="small"
              onClick={openComprobantesGallery}
            >
              Ver comprobantes
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(VacunaReintegroCard);
